import { render, staticRenderFns } from "./CustomerFlightsInfos.vue?vue&type=template&id=105f2cc0&scoped=true"
import script from "./CustomerFlightsInfos.vue?vue&type=script&lang=js"
export * from "./CustomerFlightsInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f2cc0",
  null
  
)

export default component.exports